import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  return {
    iconButton: {
      cursor: p => p.disabled ? "default" : "pointer",
      borderRadius: "4px",
      background: theme.palette.action.hover,
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0.3),
      paddingBottom: theme.spacing(0.3),
      "&:hover": {
        background: p => p.disabled ? null : theme.palette.action.selected
      },
      "&:active": {
        background: p => p.disabled ? null : theme.palette.action.active
      }
    }
  }
})
